import { useState, useEffect, useContext, useRef } from 'react';
import SessionContext from "../../SessionContext";
import { ButtonDropdown, DropdownItem, DropdownMenu, DropdownToggle, Input, InputGroup } from 'reactstrap';
import debounce from 'core/utils/debounce';

const SearchDropDown = (props) => {
    const context = useContext(SessionContext);
    const [options, setOptions] = useState([]);
    const [dropDownIsOpen, setDropDownIsOpen] = useState(false);
    const fetchOptionsRef = useRef(null);
    const fetchOptionsDebounced = useRef(debounce((searchValue) => fetchOptionsRef.current(searchValue), 300)).current;

    function updateSearchTerm(ev) {
        props.setSearchTerm(ev.target.value);
        fetchOptionsDebounced(ev.target.value);
        if (ev.target.value !== '' && !dropDownIsOpen) {
            setDropDownIsOpen(true);
        }
    }

    useEffect(() => {
      fetchOptions();
      // eslint-disable-next-line react-hooks/exhaustive-deps
    },[]);

    fetchOptionsRef.current = fetchOptions;
    function fetchOptions(searchValue){
        const currentSearch = searchValue !== undefined ? searchValue : props.searchTerm;
        const params = Object.assign({}, {page_size: props.pageSize}, {
            filters: JSON.stringify({[props.valueName]: currentSearch})
        });
        context.query(props.queryByName, params)
            .then((response) => {
                const rowOptions = [['', props.defaultLabel]];
                response.rows.forEach((row) =>  {
                    rowOptions.push([row[props.idName], row[props.valueName]])
                });
                setOptions(rowOptions);
            })
            .catch((err) => console.error('SearchDropDown fetch failed:', err));
    }

    function toggleDropDown() {
        fetchOptions();
        setDropDownIsOpen(prev => !prev);
    }

    return (
      <div className="drop-down">
          <InputGroup>
              <Input type="search" placeholder="Search"
                  onChange={updateSearchTerm}
                  value={props.searchTerm}
                  disabled={props.disabled}
              />
              <ButtonDropdown
                  toggle={toggleDropDown}
                  isOpen={dropDownIsOpen}
                  onChange={props.onSelect}
                  value={props.selectedId}
                  disabled={props.disabled}
                  >
                  <DropdownToggle caret>
                      {props.selectedName || props.defaultLabel}
                  </DropdownToggle>
                  <DropdownMenu>
                      {options.map((option, index) =>
                          <DropdownItem
                              key={index}
                              value={option[0]}
                              onClick={props.onSelect}
                          >
                              {option[1]}
                          </DropdownItem>)
                      }
                  </DropdownMenu>
              </ButtonDropdown>
          </InputGroup>
      </div>
    );
}

export default SearchDropDown;

